import React, { Component, PropTypes } from 'react';
import { PromiseState } from 'react-refetch';
import contactUsFormConnect from './connect';
import { setExtraFormData, isValidEmail } from './utils';
import { PromiseStateContainer } from '../../components';

class ContactUsForm extends Component {
  static propTypes = {
    source: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    extraDataForPosting: PropTypes.shape({
      url: PropTypes.string,
      formId: PropTypes.string.isRequired,
      lpId: PropTypes.string.isRequired,
      trackEventRegister: PropTypes.string.isRequired,
      trackEventFail: PropTypes.string.isRequired
    }),
    postContactForm: PropTypes.func.isRequired,
    postExtraData: PropTypes.func.isRequired,
    postContactFormResponse: PropTypes.instanceOf(PromiseState),
    postExtraDataResponse: PropTypes.instanceOf(PromiseState)
  };

  static defaultProps = {
    extraDataForPosting: {},
    postContactFormResponse: null,
    postExtraDataResponse: null
  };

  state = {
    name: '',
    company: '',
    email: '',
    role: 'Software Developer',
    message: ''
  };

  componentDidMount() {
    /* eslint-env browser */
    this.metricsLib = window.metricsLib;
  }

  componentWillReceiveProps(nextProps) {
    const { postExtraDataResponse } = nextProps;
    this.onPostExtraData(postExtraDataResponse);
  }

  onPostExtraData(response) {
    if (response) {
      const { name, company, email, role, message } = this.state;
      const { source, subject, extraDataForPosting } = this.props;

      const metricsData = {
        email,
        name,
        company,
        role,
        message,
        source,
        subject,
        trackData: email,
        formId: extraDataForPosting.formId,
        lpId: extraDataForPosting.lpId
      };
      if (response.rejected) {
        this.metricsLib.track(extraDataForPosting.trackEventFail, metricsData);
      }
      if (response.fulfilled) {
        this.metricsLib.track(extraDataForPosting.trackEventRegister, metricsData);
      }
    }
  }

  handleInputChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    });
  };

  submitHandler = event => {
    event.preventDefault();
    const { name, company, email, role, message } = this.state;
    const { postContactForm, postExtraData, extraDataForPosting, source, subject } = this.props;

    const formData = {
      email,
      name,
      company,
      role,
      message,
      source,
      subject
    };

    if (!isValidEmail(email)) return alert('Please enter a valid email');

    postContactForm(formData);

    if (extraDataForPosting.url) {
      const extraData = setExtraFormData(this.state);
      postExtraData(extraData);
    }
  };

  render() {
    const { name, company, email, role, message } = this.state;
    const { postContactFormResponse } = this.props;
    return (
      <section className="contact-form-section">
        <div className="container">
          <form onSubmit={this.submitHandler} className="contact-form">
            <h1 className="form-title">Contact Us</h1>
            <div className="col-xs-12 col-md-6">
              <label htmlFor="name">
                Name
                <input
                  id="name"
                  type="text"
                  name="name"
                  onChange={this.handleInputChange}
                  value={name}
                  required
                />
              </label>
            </div>
            <div className="col-xs-12 col-md-6">
              <label htmlFor="company">
                Company
                <input
                  id="company"
                  type="text"
                  name="company"
                  value={company}
                  onChange={this.handleInputChange}
                  required
                />
              </label>
            </div>
            <div className="col-xs-12 col-md-6">
              <label htmlFor="email">
                Email
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.handleInputChange}
                  required
                />
              </label>
            </div>
            <div className="col-xs-12 col-md-6">
              <label htmlFor="role">
                Role
                <select
                  id="role"
                  name="role"
                  required
                  onChange={this.handleInputChange}
                  value={role}
                >
                  <option value="Software Developer">Software Developer</option>
                  <option value="Engineering Exec / Management">
                    Engineering Exec / Management
                  </option>
                  <option value="C-Level">C-Level</option>
                  <option value="IT operations">IT operations</option>
                  <option value="Product Management">Product Management</option>
                  <option value="Sales">Sales</option>
                  <option value="Marketing">Marketing</option>
                  <option value="Security & Compliance">Security & Compliance</option>
                  <option value="Other">Other</option>
                </select>
              </label>
            </div>
            <div className="col-xs-12">
              <label htmlFor="message" className="textarea">
                Message
                <textarea
                  name="message"
                  id="message"
                  onChange={this.handleInputChange}
                  value={message}
                  required
                />
              </label>
              {postContactFormResponse
                ? <PromiseStateContainer
                    ps={PromiseState.race([postContactFormResponse])}
                    onPending={() => (
                      <button className="btn btn-lg btn-success" type="submit" disabled>
                        Sending...
                      </button>
                    )}
                    onFulFillment={() => (
                      <button className="btn btn-lg btn-success success" type="submit" disabled>
                        Thanks for getting in touch!
                      </button>
                    )}
                  />
                : <button className="btn btn-lg btn-success" type="submit">
                    send
                  </button>}
            </div>
          </form>
        </div>
      </section>
    );
  }
}

export default contactUsFormConnect(ContactUsForm);



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/ContactUsForm.js